import { z } from 'zod';
import { isoDateStringSchema, uuidSchema } from './common';

// ---------------------------------------------------------------------------
// StoreDepartment
// ---------------------------------------------------------------------------

export const storeDepartmentSchema = z.object({
  id: uuidSchema,
  storeId: uuidSchema,
  ownerSub: z.string().min(1),
  name: z.string().min(1).max(120),
  position: z.number().int().nonnegative(),
  createdAt: isoDateStringSchema,
  updatedAt: isoDateStringSchema,
});
export type StoreDepartment = z.infer<typeof storeDepartmentSchema>;

export const createStoreDepartmentDtoSchema = z.object({
  name: z.string().min(1).max(120),
});
export type CreateStoreDepartmentDto = z.infer<typeof createStoreDepartmentDtoSchema>;

export const updateStoreDepartmentDtoSchema = z.object({
  name: z.string().min(1).max(120).optional(),
});
export type UpdateStoreDepartmentDto = z.infer<typeof updateStoreDepartmentDtoSchema>;

export const reorderStoreDepartmentsDtoSchema = z.object({
  orderedIds: z.array(uuidSchema).min(1),
});
export type ReorderStoreDepartmentsDto = z.infer<typeof reorderStoreDepartmentsDtoSchema>;

// ---------------------------------------------------------------------------
// StoreArticle
// ---------------------------------------------------------------------------

export const storeArticleSchema = z.object({
  id: uuidSchema,
  storeId: uuidSchema,
  departmentId: uuidSchema.nullable(),
  ownerSub: z.string().min(1),
  name: z.string().min(1).max(200),
  notes: z.string().max(2000).nullable(),
  active: z.boolean(),
  position: z.number().int().nonnegative(),
  createdAt: isoDateStringSchema,
  updatedAt: isoDateStringSchema,
});
export type StoreArticle = z.infer<typeof storeArticleSchema>;

export const createStoreArticleDtoSchema = z.object({
  name: z.string().min(1).max(200),
  departmentId: uuidSchema.nullable().optional(),
  notes: z.string().max(2000).optional(),
});
export type CreateStoreArticleDto = z.infer<typeof createStoreArticleDtoSchema>;

export const updateStoreArticleDtoSchema = z
  .object({
    name: z.string().min(1).max(200).optional(),
    departmentId: uuidSchema.nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
    active: z.boolean().optional(),
    position: z.number().int().nonnegative().optional(),
  })
  .refine(
    (v) =>
      v.name !== undefined ||
      v.departmentId !== undefined ||
      v.notes !== undefined ||
      v.active !== undefined ||
      v.position !== undefined,
    { message: 'At least one field must be provided' },
  );
export type UpdateStoreArticleDto = z.infer<typeof updateStoreArticleDtoSchema>;
